import { useState } from 'react';
import { Notice } from '@/components/ui/primitives/Notice';
import { Button } from '@/components/ui/primitives/Button';
import { reloadToLatest, useServiceWorkerState } from '@/pwa/swState';

/**
 * "New version available" (docs/offline.md): a new service worker is installed and waiting. The update is never
 * applied silently (an open tab may hold unsaved work): Reload activates the new worker, then reloads the tab.
 * Bottom right, where the VersionBadge sits (which hides its own stale state while this shows), clear of the
 * viewer's pen tray like the toasts. Close hides it for this page (mid-markup); the update still waits, and the
 * VersionBadge's Update available / Reload stays as the way back.
 */
export function UpdateNotice() {
    const { needRefresh } = useServiceWorkerState();
    const [dismissed, setDismissed] = useState(false);
    if (!needRefresh || dismissed) return null;
    return (
        <Notice
            className="update-notice"
            role="status"
            testId="update-notice"
            onClose={() => setDismissed(true)}
            extra={(
                <Button variant="primary" size="small" onClick={() => { void reloadToLatest(); }} data-testid="update-notice-reload">
                    Reload
                </Button>
            )}
        >
            New version available
        </Notice>
    );
}
